import { isEmpty } from 'lodash';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { emailPattern } from '../../constants/globals';
import {
  basicFormValidationHandler,
  removeAdditionalSpaces,
} from '../../utils';
import UserDefaultForm from './UserDefaultForm';

const UserFormContainer = (props) => {
  const {
      saveHandler,
      translations,
      userForUpdate,
      rolesHashMapList,
      passwordChangeSignal,
      submitRef,
      generatedPassword,
      onGeneratePassword,
      loadingPassword,
    } = props || {},
    { Errors } = translations || {};

  const transferRef = useRef(null);
  const rolesInitiallySelected = useMemo(
    () => userForUpdate?.roles || [],
    [userForUpdate]
  );
  const isUserUpdateForm = userForUpdate && !passwordChangeSignal;

  const [state, setState] = useState({
    firstName: userForUpdate?.firstName || null,
    lastName: userForUpdate?.lastName || null,
    username: userForUpdate?.username || null,
    password: userForUpdate?.password || null,
    email: userForUpdate?.email || null,
    ipBrojImena: userForUpdate?.ipBrojImena || null,
    ipBaseNumber: userForUpdate?.ipBaseNumber || null,
  });

  const [errors, setErrors] = useState({});

  const changeState = useCallback((propName, value) => {
    setState((prevState) => ({ ...prevState, [propName]: value }));
  }, []);

  const onChangeHandler = (event) => {
    changeState(event.target.name, event.target.value);
  };

  const clientValidationHandler = () => {
    const { firstName, lastName, username, email, password } = state;
    let errorsObject = null;

    if (passwordChangeSignal) {
      errorsObject = basicFormValidationHandler({ password }, Errors);
    } else {
      const roles = transferRef?.current?.getItemsRight();
      errorsObject = basicFormValidationHandler(
        { firstName, lastName, username, roles, email },
        Errors
      );
    }

    if (!email) {
      errorsObject['email'] = Errors.email;
    } else if (!emailPattern.test(email)) {
      errorsObject['email'] = Errors.emailPattern;
    }

    setErrors(errorsObject);
    return !isEmpty(errorsObject);
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (clientValidationHandler()) {
      return;
    }

    const userRoles = passwordChangeSignal
      ? userForUpdate?.roles
      : transferRef?.current?.getItemsRight();

    const userForSave = {
      ...userForUpdate,
      ...state,
      firstName: removeAdditionalSpaces(state.firstName),
      lastName: removeAdditionalSpaces(state.lastName),
      roles: userRoles,
    };
    saveHandler(userForSave);
  };

  useEffect(() => {
    generatedPassword && changeState('password', generatedPassword);
  }, [generatedPassword, changeState]);

  return (
    <UserDefaultForm
      translations={translations}
      state={state}
      errors={errors}
      rolesHashMapList={rolesHashMapList}
      rolesInitiallySelected={rolesInitiallySelected}
      onChangeHandler={onChangeHandler}
      onSubmitHandler={onSubmitHandler}
      isUserUpdateForm={isUserUpdateForm}
      passwordChangeSignal={passwordChangeSignal}
      setErrors={setErrors}
      submitRef={submitRef}
      transferRef={transferRef}
      onGeneratePassword={onGeneratePassword}
      loadingPassword={loadingPassword}
    />
  );
};

export default UserFormContainer;
